import { useReducer } from 'react'

import type { HelpCardAttributes } from './data'

type AttributeValues = {
  [AttributeKey in keyof HelpCardAttributes]: HelpCardAttributes[AttributeKey] extends readonly (infer Attribute)[]
    ? Attribute
    : never
}

export type HelpFilterKey = {
  [AttributeKey in keyof HelpCardAttributes]: AttributeKey extends `${infer SingularAttributeKey}s`
    ? SingularAttributeKey
    : never
}[keyof HelpCardAttributes]

export type HelpFilters = {
  [Key in HelpFilterKey]: AttributeValues[`${Key}s`] | null
}

const filtersReducer = (filters: HelpFilters, nextFilters: Partial<HelpFilters>) => ({ ...filters, ...nextFilters })

const useFilters = () => {
  return useReducer(filtersReducer, {
    contentType: null,
    topic: null,
    role: null,
  })
}

export default useFilters
